// Filename - ./components/Navbar.js

import { FaBars } from "react-icons/fa";
import { NavLink as Link } from "react-router-dom";
import styled from "styled-components";

export const Nav = styled.nav`
    background:rgba(250, 250, 250, 0.36);
    height: 60px;
    display: flex;
    justify-content: space-between;
    padding: 0.2rem calc((100vw - 700px) / 2);
    z-index: 12;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    borderWidth: 10px;
    borderColor: rgb(255, 255, 255);
    width 100%;
`;

export const NavLink = styled(Link)`
    color:rgb(255, 255, 255);
    font-size: 30px;
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0 2rem;
    height: 100%;
    width: max-content;
    white-space: "nowrap";
    cursor: pointer;
    &.active {
        color:rgb(255, 255, 255);
    }
`;

export const Bars = styled(FaBars)`
    display: none;
    color: #808080;
    @media screen and (max-width: 768px) {
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        transform: translate(-100%, 75%);
        font-size: 1.8rem;
        cursor: pointer;
    }
`;

export const NavMenu = styled.div`
    display: flex;
    align-items: center;
    margin-right: -24px;
    /* Second Nav */
    /* margin-right: 24px; */
    /* Third Nav */
    /* width: 100vw;
 */
    @media screen and (max-width: 768px) {
        display: none;
    }
`;

export const NavWrapper = styled.div`
    flex-direction: column;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  
`;